import * as React from "react";
import { SVGProps } from "react";

const Ardor = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1984 1726" {...props}>
    <path fill="#1562a1" d="M984.3 0 0 1719.5h490.8l747.4-1282L984.3 0z" />
    <path
      fill="#0c426c"
      d="m525.7 1726.1 653.8-380.7-251.3-311.1-402.5 691.8z"
    />
    <path
      fill="#3c87c7"
      d="m1411.9 748.7-471.4 257 590.4 720h453.3l-572.3-977z"
    />
  </svg>
);

export default Ardor;
